const numeral = require('numeral');



// Format as USD currency
// export const formattedAmount =(amount)=> numeral(amount).format('$0,0.00'); 
export const formattedAmount = (amount) => `₵${numeral(amount).format('0,0.00')}`;
 

export const getSelectOptions=(data,LabelKey,valueKey)=>{
    console.log('select option',data);
    
const options=data && data?.map((d)=>{
return{
    label:d[LabelKey],
    value:d[valueKey],
    _id:d._id
}
})
return options
}